export const EMPRESA_CONFIG_BASE = '/configuracion/empresa';

export const EMPRESA_CONFIG_TILE_KEYS = [
  'grupo-empresas',
  'proveedor-empresa',
  'contacto-grupo',
  'contacto-empresa',
  'servicio-empresa',
  'precios',
  'etiquetas',
  'Regimen',
] as const;

export const ETIQUETA_BASE = `${EMPRESA_CONFIG_BASE}/etiquetas`;

export function etiquetaNewPath(): string {
  return `${ETIQUETA_BASE}/new`;
}

export function etiquetaEditPath(id: number | string): string {
  return `${ETIQUETA_BASE}/${id}/edit`;
}

export const REGIMEN_BASE = `${EMPRESA_CONFIG_BASE}/Regimen`;

export function regimenNewPath(): string {
  return `${REGIMEN_BASE}/new`;
}

export function regimenEditPath(id: number | string): string {
  return `${REGIMEN_BASE}/${id}/edit`;
}
